var version = {
    "name":      "dativery",
    "buildDateCode": "20260902-111527",
    "buildDate": "Wed Sep 02 2026 11:15:27 GMT+0000 (Coordinated Universal Time)",
    "version":   "2.2.0",
    "uiVersion": "2.2.0-20260902-111527",
    "backupUIVersion": "2.2.0-20250519-102244"
}
;
 export default version;